import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from './router'

//plugin para persistir los datos de vuex
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //base_url:'http://backendplp.test/api/', //fermin
    base_url:'http://localhost/produccion-plp/backend/public/api/',  //claudio
    //base_url:'http://192.168.1.174/produccion-plp/backend/public/api/',   // daniel
    //base_url:'http://localhost/produccion-plp/backend/public/api/',
    url_socket:'http://localhost:3000',
    download_url: '',
    user:JSON.parse(localStorage.getItem('user_prod') || null),
    roles_prod:localStorage.getItem('roles_prod')? JSON.parse(localStorage.getItem('roles_prod')).roles : [],
    permisos_prod:localStorage.getItem('permisos_prod')? JSON.parse(localStorage.getItem('permisos_prod')) : [],
    permissions:[],
    menus:JSON.parse(localStorage.getItem('menus_prod') || null),
    authenticated:JSON.parse(localStorage.getItem('auth_prod') || false),
    headers:JSON.parse(localStorage.getItem('cabecera_prod') || null),
    token:JSON.parse(localStorage.getItem('token_prod') || null),
    drawer:false,
    loading:{
      titulo:'Cargando...',
      state:false
    },
    lista:[],
    columnas:[],
    total_paginas:1
  },
  mutations: {
    setSession(state,credenciales){
        
      localStorage.setItem("auth_prod",JSON.stringify({auth:true}));
      localStorage.setItem("user_prod",JSON.stringify(credenciales.user));
      localStorage.setItem("token_prod",JSON.stringify({token:credenciales.access_token}));
      localStorage.setItem("menus_prod",JSON.stringify(credenciales.menus));
      localStorage.setItem("roles_prod",JSON.stringify({roles:['admin']}));
      localStorage.setItem("permisos_prod",JSON.stringify(credenciales.roles));
      localStorage.setItem("cabecera_prod",JSON.stringify({
        headers:{
          'Content-Type':'application/json;charset=utf-8',
          'Authorization':`Bearer ${credenciales.access_token}`
        }
      }));

      state.authenticated = JSON.parse(localStorage.getItem("auth_prod")).auth;
      state.token = JSON.parse(localStorage.getItem("token_prod")).token;
      state.user = JSON.parse(localStorage.getItem("user_prod"));
      if(!credenciales.kiosk){
        state.menus = JSON.parse(localStorage.getItem("menus_prod"));
      }
      
      state.roles_prod = JSON.parse(localStorage.getItem("roles_prod")).roles;
      state.permisos_prod = JSON.parse(localStorage.getItem("permisos_prod"));
      state.headers = JSON.parse(localStorage.getItem("cabecera_prod"));
      state.permissions = credenciales.permissions;
      
      if(credenciales.kiosk){
        router.push('/registroslaboratorio_kiosko');
      }else{
        router.push('/dashboard');
      }

        /* state.authenticated = true;
        state.user = credenciales.user;
        state.token = credenciales.access_token;
        state.roles = ['admin'];
        state.permisos = credenciales.roles;
        state.menus = credenciales.menus;
        // state.headers = {
        //   content_type:'application/json;charset=utf-8',
        //   authorization:`Bearer ${state.token}`
        // }
        state.headers = 
        {
          headers:{
            'Content-Type':'application/json;charset=utf-8',
            'Authorization':`Bearer ${state.token}`
          }
        }; */
    },
    removeSession(state){
      // console.log('llego aqui al remove');

      localStorage.removeItem("auth_prod");
      localStorage.removeItem("token_prod");
      localStorage.removeItem("user_prod");
      localStorage.removeItem("menus_prod");
      localStorage.removeItem("roles_prod");
      localStorage.removeItem("cabecera_prod");



      state.authenticated = false;
      state.user = null;
      state.roles_prod = null;
      state.menus = null;
      state.token = null;
      state.headers = null;
      state.permissions = [];
      router.push('/login');
    },
    mostrarLoading(state,payload){
      state.loading.titulo = payload.titulo;
      state.loading.color = payload.color;
      state.loading.state = true;
    },
    ocultarLoading(state){
      state.loading.state = false;
    },
    actualizarBaseUrl(state,url){
      state.base_url = url;
      // console.log('base_url en store',state.base_url);
    },
    actualizarUrlSocket(state,url){
      state.url_socket = url;
      // console.log('url_socket en store',state.url_socket);
    },
    actualizarDownloadUrl(state, url){
      state.download_url = url;
    },
    //Actualiza los datos de Tabla Paginada
    actualizarTablaPaginada(state, data){
      state.lista = data.lista;
      state.columnas = data.columnas;
      state.total_paginas = data.total_paginas;
    },
    actualizarLista(state, data){
      state.lista = data.lista;
      //state.columnas = data.columnas;
      state.total_paginas = data.total_paginas;
    }
  },
  actions: {
    // login({commit,state},credentials){
    //     console.log(credentials);
    //     commit('mostrarLoading','Iniciando Sesión...')
    //     axios.post(state.base_url+'login',{
    //         email:credentials.email,
    //         password:credentials.password
    //     }).then((response)=>{
    //         console.log('respuesta logueo',response.data);
    //         commit('setSession',response.data);
    //         commit('ocultarLoading')
    //     }).catch((error)=>{
    //       console.log(error)
    //       commit('ocultarLoading')
    //     })
    // },
    iniciarSession({commit,state},datos){
      commit('setSession',datos)
    },
  },
  plugins: [createPersistedState({
    paths: ['base_url','url_socket','download_url','user','roles','menus','authenticated','token','headers','lista','columnas','total_paginas', 'permisos']
  })]
})
